export function getUnknownErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error) {
    return error.message || fallback;
  }
  if (error && typeof error === 'object') {
    const candidate = error as {
      name?: string;
      message?: string;
      response?: { data?: { message?: string } };
    };
    return candidate.response?.data?.message ?? candidate.message ?? fallback;
  }
  return fallback;
}

export function getUnknownErrorName(error: unknown): string | undefined {
  if (error && typeof error === 'object' && 'name' in error) {
    const name = (error as { name?: unknown }).name;
    return typeof name === 'string' ? name : undefined;
  }
  return undefined;
}
